import { defineComponent as a, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as h } from "vue";
const f = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "cb3ce7b1-8ee1-4990-87b4-c07d21932b84" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#cb3ce7b1-8ee1-4990-87b4-c07d21932b84)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "m0 166.9 258-31.7 254 31.7v178l-251.4 41.3L0 344.9z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 0h512v166.9H0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 344.9h512V512H0z"
}, null, -1), b = { fill: "none" }, x = ["r"], z = /* @__PURE__ */ a({
  __name: "bg",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (w, y) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (c(), i("title", k, d(t.flagName), 1)) : _("", !0),
        p,
        g,
        v
      ]),
      e("g", b, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: h({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, f));
  }
});
export {
  z as default
};
//# sourceMappingURL=bg-4ea93af4.js.map
